import { Box } from '@chakra-ui/react'
import { FiAlertCircle } from 'react-icons/fi'
import { IoMdClose } from 'react-icons/io'

export default function DrawerErrorBanner({ message, onDismiss }) {
  if (!message) return null
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      w="full"
      px={3}
      py={2}
      borderRadius="md"
      className="bg-fpx-red text-white"
    >
      <Box display="flex" alignItems="center" gap={2}>
        <FiAlertCircle className="text-xl shrink-0" />
        <span className="text-sm">{message}</span>
      </Box>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="p-1 rounded hover:bg-white/10"
          aria-label="Dismiss error"
        >
          <IoMdClose className="text-xl" />
        </button>
      )}
    </Box>
  )
}
